import { render } from "./PatientListViewer.vue?vue&type=template&id=3c0cee08&scoped=true"
import script from "./PatientListViewer.vue?vue&type=script&lang=js"
export * from "./PatientListViewer.vue?vue&type=script&lang=js"

import "./PatientListViewer.vue?vue&type=style&index=0&id=3c0cee08&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3829526335/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0cee08"]])

export default __exports__